import { Action } from '@ngrx/store';

export enum FollowCountryActionTypes {
  LoadByFollow = '[API] Load countries by follow',
  LoadByFollowSuccess = '[API] Load countries by follow Success',
  LoadByFollowFail = '[API] Load countries by follow Fail',
  AddMany = '[FollowCountry] Add many'
}

export class LoadByFollow implements Action {
  readonly type = FollowCountryActionTypes.LoadByFollow;
  constructor(public id: number) {}
}

export class LoadByFollowSuccess implements Action {
  readonly type = FollowCountryActionTypes.LoadByFollowSuccess;
  constructor(public countries: any[]) {}
}

export class LoadByFollowFail implements Action {
  readonly type = FollowCountryActionTypes.LoadByFollowFail;
  constructor(public error: any) {}
}

export class AddMany implements Action {
  readonly type = FollowCountryActionTypes.AddMany;
  constructor(public countries: any[]) {}
}

export type FollowCountryActionsUnion =
  | LoadByFollow
  | LoadByFollowSuccess
  | LoadByFollowFail
  | AddMany;
